import React, { memo } from 'react';
import BlockMarkdown from './BlockMarkdown';
import ClaimSupportFooter from '../ClaimSupportFooter';
import { extractBlockItems, normalizePriorityLabel, priorityTone } from './structuredBlockUtils';
import styles from './structuredResponse.module.css';

function RecommendationBlock({ block, renderContext }) {
    const items = extractBlockItems(block);
    if (!items.length) return null;

    return (
        <section className={styles.recommendationBlock} aria-label={block.title || 'Recommendations'}>
            {block.title ? <h3 className={styles.blockTitle}>{block.title}</h3> : null}
            <ol className={styles.recommendationList}>
                {items.map((item, index) => {
                    const title = item.title || item.label;
                    const description = item.description || item.content || item.markdown;
                    const priority = normalizePriorityLabel(item.priority);
                    const tone = priorityTone(priority);
                    if (!title && !description) return null;
                    return (
                        <li key={item.id || `rec-${index}`} className={styles.recommendationItem}>
                            <div className={styles.recommendationHeader}>
                                {title ? <div className={styles.recommendationTitle}>{title}</div> : null}
                                {priority ? (
                                    <span className={`${styles.priorityBadge} ${styles[`priority${tone}`]}`}>
                                        {priority}
                                    </span>
                                ) : null}
                            </div>
                            {description ? (
                                <BlockMarkdown content={description} {...renderContext} />
                            ) : null}
                        </li>
                    );
                })}
            </ol>
            <ClaimSupportFooter block={block} renderContext={renderContext} />
        </section>
    );
}

export default memo(RecommendationBlock);
